// The phone app's screen registry. On a phone, DashboardLayout renders the
// screen registered here for a tab; a tab with no phone screen renders the
// desktop (advanced) screen under a slim "best on a computer" strip.
//
// Adding a phone screen = one line here. Screens live in src/mobile/screens and
// are built from src/mobile/kit, and every write goes through the same services
// as the desktop (see orders/services/deskActions.js) — never a copy.
import { lazyWithReload } from '../shared/utils/lazyWithReload';

export const PHONE_SCREENS = {
    // Home: the phone summary (sales, new vs repeat, payments) — not the desktop
    // dashboard squeezed into a column.
    dashboard: { capability: 'canViewDashboard', load: lazyWithReload(() => import('./screens/HomePhone')) },
    orders: { capability: 'canViewOrders', load: lazyWithReload(() => import('./screens/OrdersMobile')) },
    customers: { capability: 'canViewCustomers', load: lazyWithReload(() => import('./screens/CustomersPhone')) },
    telecaller: { capability: 'canViewTelecallerWorkspace', load: lazyWithReload(() => import('./screens/TelecallerPhone')) },
    complaints: { capability: 'canViewComplaints', load: lazyWithReload(() => import('./screens/ComplaintsPhone')) },
    tracking: { capability: 'canViewTracking', load: lazyWithReload(() => import('./screens/TrackingPhone')) },
    cancelled: { capability: 'canViewOrders', load: lazyWithReload(() => import('./screens/CancelledPhone')) },
    archived: { capability: 'canViewOrders', load: lazyWithReload(() => import('./screens/ArchivedPhone')) },
};

// Desktop components that already ARE their phone version (they switch layout
// themselves), so they get no "advanced" strip.
export const PHONE_NATIVE = new Set(['chat', 'india-post', 'dtdc']);
